<template>
  <v-dialog
      fullscreen
      eager
      v-model="dialog"
      hide-overlay
      content-class="form-dialog"
  >
    <v-card
        elevation="0"
    >
      <v-col class="text-right px-4">
        <v-btn icon @click="clearDialogForm" ><v-icon large color="primary">close</v-icon></v-btn>
      </v-col>

      <v-card-text>
        <v-form ref="form">
          <v-row justify="space-around">
            <v-col cols="12" md="5">
              <h3 class="font-weight-bold mb-5">{{ $t('buttons:add-specific', { specific: $t('common:building') }) }}</h3>
              <h5 class="primary--text font-weight-medium">{{ $t('common:general') }}</h5>
                <!-- Name -->
                <DuplicateCheckField
                    ref="duplBuildingName"
                    :value="building.name"
                    :label="$t('common:name')"
                    item-additional-info-field="objectNumber"
                    item-additional-info-field2="address"
                    required
                    tab-index="1"
                    item-text="name"
                    @input="building.name = $event"
                    @checkForDuplicates="checkByBuildingName"
                    @clickedShowItem="showBuilding"
                />

                <!-- Object Number -->
                <DuplicateCheckField
                    ref="duplObjectNumber"
                    :value="building.objectNumber"
                    :label="$t('common:object-number')"
                    item-additional-info-field="objectNumber"
                    item-additional-info-field2="address"
                    tab-index="2"
                    item-text="name"
                    @input="building.objectNumber = $event"
                    @checkForDuplicates="checkByObjectNumber"
                    @clickedShowItem="showBuilding"
                />

                <h5 class="primary--text font-weight-medium mt-5">{{ $t('common:address') }}</h5>
                <!-- Input Address -->
                <DuplicateCheckField
                    ref="duplAddress"
                    :value="building.address_street"
                    :label="$t('common:address')"
                    item-additional-info-field="objectNumber"
                    item-additional-info-field2="address"
                    tab-index="3"
                    item-text="name"
                    @input="building.address_street = $event"
                    @checkForDuplicates="checkByAddress"
                    @clickedShowItem="showBuilding"
                />

                <v-row>
                  <v-col class="py-0">

                    <!-- Input ZIP -->
                    <v-text-field
                        outlined
                        v-model="building.address_zip"
                        :label="$t('common:zip')"
                        clearable
                        tabindex="4"
                        @input="getCityProvinceByZIP"
                    />

                  </v-col>
                  <v-col class="py-0">

                    <!-- Input City -->
                    <v-text-field
                        outlined
                        v-model="building.address_city"
                        :label="$t('common:city')"
                        clearable
                        tabindex="5"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="py-0">

                    <!-- Input Select Country -->
                    <v-select
                        :items="restCountry"
                        item-text="translatedName"
                        item-value="id"
                        :menu-props="{ bottom: true, offsetY: true }"
                        v-model="building.country"
                        outlined
                        :label="$t('common:country')"
                        @change="updateProvince"
                        tabindex="6"
                        clearable
                    />
                  </v-col>
                  <v-col class="py-0">

                    <!-- Input Select State -->
                    <v-select
                        :items="restProvince"
                        item-text="translatedName"
                        item-value="id"
                        :menu-props="{ bottom: true, offsetY: true }"
                        v-model="building.province"
                        outlined
                        :label="$t('common:province')"
                        tabindex="7"
                        clearable
                    />
                  </v-col>
                </v-row>

                <v-btn
                  v-if="building.address_street && building.address_zip && building.address_city"
                  @click="addressToCoordinates"
                  outlined
                  color="primary"
                >
                  {{ $t('book/building:overview.form.btns.gps')}}
                </v-btn>

                <!-- Location of Building with Map Visualization -->
                <div class="subtitle-2 mt-5">{{ $t("book/building:overview.form.location-building") }}</div>
                <OpenStreetMap
                  ref="map"
                  :lat="building.latitude"
                  :long="building.longitude"
                  @changeLocation="changeLocation($event)"
                  height="400"
                ></OpenStreetMap>

                <v-row>
                  <v-col cols="6">
                    <!-- Input Latitude -->
                    <v-text-field
                        outlined
                        v-model="building.latitude"
                        :label="$t('book/building:overview.form.labels.latitude')"
                        :rules="[ruleLatitude($t('utils:rules.latitude'))]"
                        clearable
                        type="number"
                    />
                  </v-col>
                  <v-col cols="6">
                    <!-- Input Longitude -->
                    <v-text-field
                        outlined
                        v-model="building.longitude"
                        :label="$t('book/building:overview.form.labels.longitude')"
                        :rules="[ruleLatitude($t('utils:rules.longitude'))]"
                        clearable
                        type="number"
                    />
                  </v-col>
                </v-row>
            </v-col>
            <v-col cols="12" md="5">
              <h5 class="primary--text font-weight-medium mt-11">{{ $t('book/building:common.organisation-info') }}</h5>
              <!-- Input Owner -->
              <CustomerTypeahead
                  ref="ownerTypeahead"
                  :value="building.owner"
                  @input="building.owner = $event"
                  :label="$t('common:owner')"
                  tabindex="8"
                  required
              />

              <!-- Input Operator -->
              <CustomerTypeahead
                  ref="operatorTypeahead"
                  :value="building.operator"
                  @input="building.operator = $event"
                  :label="$t('common:operator')"
                  tabindex="9"
                  required
              />

              <h5 class="primary--text font-weight-medium mt-5">{{ $t('book/building:common.bill-address') }}</h5>

              <v-row>
                <v-col cols="12" sm="6" md="6">
                  <v-select
                      outlined
                      :items="buildingOwnerOperator"
                      item-value="id"
                      item-text="name"
                      :hint="$t('book/building:common.copy-address')"
                      :label="$t('book/building:overview.form.labels.owner-operator')"
                      persistent-hint
                      :menu-props="{ bottom: true, offsetY: true}"
                      clearable
                      @input="copyCustomerAddress"
                      return-object
                  />
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-select
                      outlined
                      :items="buildingOwnerOperator"
                      item-value="id"
                      item-text="name"
                      :hint="$t('book/building:common.copy-reg-number')"
                      :label="$t('book/building:overview.form.labels.owner-operator')"
                      persistent-hint
                      :menu-props="{ bottom: true, offsetY: true}"
                      clearable
                      @input="copyRegNumber"
                      return-object
                  />
                </v-col>
              </v-row>

              <!-- Input Name of billing Person -->
              <v-text-field
                  outlined
                  v-model="building.billingPersonName"
                  :label="$t('common:name')"
                  clearable
                  tabindex="10"
                  class="mt-5"
              />

              <v-text-field
                  outlined
                  v-model="building.billingVatId"
                  :label="$t('book/building:common.reg-number')"
                  clearable
                  tabindex="11"
              />

              <!-- Input Billing address -->
              <v-text-field
                  outlined
                  v-model="building.billing_street"
                  :label="$t('common:address')"
                  clearable
                  tabindex="12"
              />
              <v-row>
                <v-col class="py-0">

                  <!-- Input Billing ZIP -->
                  <v-text-field
                      outlined
                      v-model="building.billing_zip"
                      :label="$t('common:zip')"
                      clearable
                      tabindex="13"
                  />
                </v-col>
                <v-col class="py-0">

                  <!-- Input Billing City -->
                  <v-text-field
                      outlined
                      v-model="building.billing_city"
                      :label="$t('common:city')"
                      clearable
                      tabindex="14"
                  />
                </v-col>

              </v-row>
              <BaseButton
                  color="primary"
                  :btn-text="$t('buttons:add-specific', { specific: $t('common:building')})"
                  @clickedButton="postBuilding"
                />

              <DirtyConfirmButtonDialog
                  ref="cancelDialog"
                  :btn-text="$t('buttons:cancel')"
                  color="grey"
                  :dialog-title="$t('dialog:dirty-save-btn-title')"
                  :dialog-text="$t('dialog:dirty-save-btn-dialog')"
                  :button1-text="$t('dialog:dirty-save-btn-1-text')"
                  :button2-text="$t('dialog:dirty-save-btn-2-text')"
                  @clickedButton="clearDialogForm()"
                  :dataToWatch="building"
                  hideOverlay
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
    <template v-slot:activator="{on, attrs}">
      <v-btn rounded color="primary" elevation="0" v-bind="attrs" v-on="on">
        <v-icon>add</v-icon>
        <span class="d-none d-sm-flex">
          {{ $t('buttons:add-specific', { specific: $t('common:building') }) }}
        </span>
      </v-btn>
    </template>
  </v-dialog>
</template>

<script>
import {ruleRequired, ruleLatitude, ruleLongitude} from "@/modules/core/services/rules";
import BuildingService from "@/modules/book/services/building-service";
import CustomerService from "@/modules/core/services/customer-service";
import CountryService from "@/modules/core/services/country-service";
import Utils from "@/modules/core/services/utils";
import DataUtils from "@/modules/core/services/data-utils";
import GPSUtils from "@/modules/core/services/gps-utils";

import Building from "@/modules/book/data/building";
import Customer from "@/modules/core/data/customer";

import CustomerTypeahead from "@/modules/core/components/CustomerTypeAhead";
import BaseButton from "@/modules/core/components/Base/BaseButton";

import DirtyConfirmButtonDialog from "@/modules/core/components/TwoButtonDialog/DirtyConfirmButtonDialog";

import DuplicateCheckField from "@/modules/core/components/DuplicateCheckField";
import DuplicateCheckService from "@/modules/core/services/duplicate-check-service";
import {mapGetters} from "vuex";

export default {
  name: 'BuildingDialogForm',
  components: {
    DuplicateCheckField,
    BaseButton,
    CustomerTypeahead,
    OpenStreetMap: () => import('@/modules/core/components/OpenStreetMap/OpenStreetMap'),
    DirtyConfirmButtonDialog
  },
  data() {
    return {
      restBuilding: [],
      dialog: false,

      building: new Building(),
      restCountry: [],
      restProvince: [],
      buildingOwnerOperator: [],
      customerOfLoggedIn: new Customer()
    }
  },
  computed: {
    currentLang() {
      return this.$store.state.translation.language;
    },
    ...mapGetters('auth', ['isAdmin']),
  },
  methods: {
    ruleRequired,
    ruleLatitude,
    ruleLongitude,

    postBuilding() {
      if (!this.$refs.form.validate()) {
        return;
      }

      if (!this.isAdmin
          && !Utils.checkCustomerWithDescendentsForBuilding(this.customerOfLoggedIn, this.building)) {
        Utils.showFailureSnackbar(this.$t('book/building:building.form-sidebar.snackbar.customer'))
        return;
      }

      BuildingService.postToAPI(this.building,
        (res) => {
          Utils.showSuccessSnackbar(this.$t('snackbar:add-success', {name: this.$t('common:building')}));
          this.$router.push(`/${this.$store.state.manager.bookModuleUrl}/buildings/edit/${res.data.id}#dashboard`);
        },
        () => {
          this.dialog = false
          Utils.showFailureSnackbar(this.$t('snackbar:add-failure', {name: this.$t('common:building')}))
        }
      );
    },

    clearDialogForm() {
      this.$refs.duplBuildingName.reset();
      this.$refs.duplObjectNumber.reset();
      this.$refs.duplAddress.reset();
      this.$refs.form.reset();
      this.dialog = false;
    },

    updateProvince() {
      if (this.building.country === null)
        return;

      CountryService.readProvincesOfCountry(this.building.country,
        (res) => {
          this.restProvince = res.data;
          this.building.province = this.restProvince[0].id;
          Utils.translateAllProvinces(this.restCountry,this.restProvince,this.building.country);
        },
        (error) => {
          Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('common:province_plural')}))
          this.$logger.error(error);
        }
      )
    },

    changeLocation(latlong) {
      this.building.latitude = latlong.lat;
      this.building.longitude = latlong.lng;
    },

    /**
     * Reads and sets the building city and province
     * by the entered ZIP
     */
    getCityProvinceByZIP() {
      // check if there is a zip and country set for the building
      if (this.building.address_zip && this.building.country) {

        const countryName = GPSUtils.getCountryNameById(this.building.country, this.restCountry);

        if (GPSUtils.isValidZIP(countryName.toLowerCase(), this.building.address_zip)) {
          GPSUtils.readCityProvinceByZIP(
              this.building.address_zip,
              countryName,
              this.$store.state.translation.language,
              this.restProvince,
              (res) => {
                this.building.address_city = res.city;
                this.building.province = res.province;
              },
              () => {
                Utils.showFailureSnackbar(this.$t('book/building:overview.form.snackbar.zip-to-city-fail'))
              }
          )
        }
      }
    },

    addressToCoordinates() {
      GPSUtils.convertAddressToCoordinates(this.building.address_street, this.building.address_zip, this.building.address_city,
        (res) => {
          if(res.data.length > 0) {
            this.building.latitude = res.data[0].lat;
            this.building.longitude = res.data[0].lon
            if(this.$refs.map) {
              this.$refs.map.recenterMap(res.data[0].lat, res.data[0].lon);
            }
          } else {
            GPSUtils.getCoordinatesByZipCity(this.building.address_zip, this.building.address_city,
              (resp) => {
                if(resp.data.length > 0) {
                  this.building.latitude = resp.data[0].lat;
                  this.building.longitude = resp.data[0].lon
                  if(this.$refs.map) {
                    this.$refs.map.recenterMap(resp.data[0].lat, resp.data[0].lon);
                  }
                } else {
                  Utils.showFailureSnackbar(this.$t('book/building:common.snackbar.gps-search'));
                }
              }
            )
          }
        },
        () => {
          Utils.showFailureSnackbar(this.$t('book/building:common.snackbar.gps-search'));
        }
      )
    },

    /**
     * Adds a customer object to the select-array if it is not already included
     * It also checks if customer objects are in the select-array, which doesn't match with
     * the operator/owner id. If this is the case, it will be removed from the select-array
     *
     * @param newCustomer customer object to add to buildingOwnerOperator
     */
    addCustomerToSelection(newCustomer) {
      if (!this.buildingOwnerOperator.some(customer => customer.id === newCustomer.id)) {
        this.buildingOwnerOperator.push(newCustomer);
      }
      let notNeededCustomers = this.buildingOwnerOperator.filter(customer => customer.id !== this.building.operator && customer.id !== this.building.owner);

      let objectIndexToRemove = this.buildingOwnerOperator.indexOf(notNeededCustomers[0]);
      if(objectIndexToRemove !== -1) {
        this.buildingOwnerOperator.splice(objectIndexToRemove, 1);
      }
    },

    /**
     * Copys address and name from selected customer.
     *
     * @param item customer to copy data from
     */
    copyCustomerAddress(item) {
      if (item) {
        this.building.billingPersonName = item.name;
        this.building.billing_street = item.street;
        this.building.billing_zip = item.zip;
        this.building.billing_city = item.city;
        this.building.billingVatId = item.vatId;
      }
    },

    /**
     * Copys registration number of customer to building billing uid
     *
     * @param item customer to copy reg number from
     */
    copyRegNumber(item) {
      if (item) {
        this.building.billingVatId = item.vatId;
      }
    },

    defineAddress(items) {
      items.forEach((item) => {
        item.address = item.address_street + ", " + item.address_zip + " " + item.address_city;
      })
    },

    checkByBuildingName(term) {
      DuplicateCheckService.checkBuildings('NAME', term,
          (res) => {
            this.defineAddress(res.data);
            this.$refs.duplBuildingName.fillData(res.data);
          },
          (serviceName, error) => {
            this.handleDuplicateErrorCause(serviceName, error);
          }
      )
    },

    checkByObjectNumber(term) {
      DuplicateCheckService.checkBuildings('OBJECT_NUMBER', term,
          (res) => {
            this.defineAddress(res.data);
            this.$refs.duplObjectNumber.fillData(res.data);
          },
          (serviceName, error) => {
            this.handleDuplicateErrorCause(serviceName, error);
          }
      )
    },

    checkByAddress(term) {
      DuplicateCheckService.checkBuildings('ADDRESS', term,
          (res) => {
            this.defineAddress(res.data);
            this.$refs.duplAddress.fillData(res.data);
          },
          (serviceName, error) => {
            this.handleDuplicateErrorCause(serviceName, error);
          }
      )
    },

    handleDuplicateErrorCause(serviceName, error) {
      if (error.response.headers.error_cause && this.$t('error-causes:' + error.response.headers.error_cause)) {
        Utils.showWarningSnackbar(this.$t("error-causes:" + error.response.headers.error_cause));
      } else {
        this.$logger.error(serviceName + error);
      }
    },

    showBuilding(item) {
      window.open(`/${this.$store.state.manager.bookModuleUrl}/buildings/edit/${item.id}#dashboard`)
    }
  },
  watch: {
    'building.owner'(value) {
      if (value) {
        CustomerService.readAddress(value,
            (res) => {
              this.addCustomerToSelection(res.data);
            }
        )
      }
    },
    'building.operator'(value) {
      if (value) {
        CustomerService.readAddress(value,
            (res) => {
              this.addCustomerToSelection(res.data);
            }
        )
      }
    },

    currentLang() {
      Utils.sleep(500).then(() => {
        this.$refs.form.resetValidation()

        // translate countries
        for(let i = 0; i < this.restCountry.length; i++) {
          this.restCountry[i].translatedName = Utils.translateCountry(this.restCountry[i].name)
        }

        // translate provinces
        for(let j = 0; j < this.restProvince.length; j++) {
          this.restProvince[j].translatedName = Utils.translateProvinces(GPSUtils.getCountryNameById(this.building.country, this.restCountry), this.restProvince[j].name)
        }
      })
    },

    dialog() {
      if(this.dialog) {
        if(this.$route.query.openForm) {//checks if url includes openForm=true and removes it so on refreshed dialog won't open again.
          this.$router.replace(`/${this.$store.state.manager.bookModuleUrl}/buildings`);
        }

        this.$refs.map.refreshMap();

        CountryService.readAllFromAPI(
          (res) => {
            this.restCountry = res.data;
            var defaultCountry = res.data[0];
            this.building.country = defaultCountry.id;

            for(var i = 0; i < this.restCountry.length; i++) {
              this.restCountry[i].translatedName = Utils.translateCountry(this.restCountry[i].name)
            }

            CountryService.readProvincesOfCountry(defaultCountry.id,
              (resP) => {
                this.restProvince = resP.data;
                this.building.province = resP.data[0].id;

                for(var i = 0; i < this.restProvince.length; i++) {
                  this.restProvince[i].translatedName = Utils.translateProvinces(defaultCountry.name, this.restProvince[i].name)
                }
                this.$refs.cancelDialog.startWatch();
              },
              (error) => {
                Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('common:province_plural')}))
                this.$logger.error(error);
              }
            )
            this.$refs.cancelDialog.startWatch();
          },
          (error) => {
            Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('book/building:common.snackbar.country')}))
            this.$logger.error(error);
          }
        )

        //load and set the default customer data to the customer fields
        CustomerService.readProfileFromAPI(
          (res) => {
            if(res.data) {
              this.customerOfLoggedIn = DataUtils.parseDataToSingleObject(res.data, Customer);
              this.building.owner = this.customerOfLoggedIn.id;
              this.building.operator = this.customerOfLoggedIn.id;

              this.$refs.ownerTypeahead.initialise(this.building.owner);
              this.$refs.operatorTypeahead.initialise(this.building.operator);
            }
            this.$refs.cancelDialog.startWatch();
          },
          (error) => {
            Utils.showWarningSnackbar(this.$t('book/building:overview.form.snackbar.customer-load-failure'))
            this.$logger.error(error);
          }
        )
        this.$refs.cancelDialog.startWatch();
      }
    }
  }
}
</script>
